<template>

	<div class="flex_center bg_main" :style="'height:'+boxHeight+'px;'">
		
		<div class="padding15 center" style="max-width: 400px;width:80%;">
			
			<img v-if="logo!=''" :src="logo" mode="heightFix" class="height40 lineh1 block automargin" />

			<div class="flex_row_s padding0 margint15 marginb15 fullwidth">
				<div  class="uni-icon uni-icon-person size2r marginr5 color_green"></div>
				<div class="uni-panel-h relative fullwidth">
					<input @input="inputPhone" style="min-height:40px;" class="size4 uni-input bg_white   fullwidth left padding7 border" xxxtype="number" v-model="phone" focus placeholder="手机号或账号" />
					
					<div class="absolute right0 top0" style="min-height:40px;z-index:2;" >
						<div v-if="phone.length==11 && phone.match(/^\d+$/)" class=" color_green padding7 ellips width200r automargin radius5" @click="sendSmsCode">获取验证码</div>
					</div>
				</div>
			</div>
			
			<div class="flex_row_s padding0 marginb15 fullwidth">
				<div  class="uni-icon uni-icon-locked size2r  marginr5  color_green"></div>
				<div class="uni-panel-h fullwidth">
					<input style="min-height:40px;" class="size4 uni-input bg_white fullwidth left   padding7 border" type="number" v-model="smsCode" :placeholder="pwPlaceholder" />
				</div>
			</div>
			
			<!--
			<div id="verifyimg_box" ref="verifyimg_box" class="hidden fullwidth relative " >
				<img @click="selectWord" :src="chineseverifyImg"  class=" fullwidth"/>
				<div v-for="(item,index) in rightArr" class="absolute " :style="'top:'+item.top+'px;left:'+item.left+'px;'">
					<img @click="selectWord" :src="item.img"  class=" width24"/>
				</div>
			</div>
			-->
			
			<div class="bg_green color5 padding7 automargin width100 radius5" @click="doLogin">登录</div>
			
			
			
		</div>
		
		<ydverify :showPopup="showPopup" @imgVerifySuccessCallback="imgVerifyCallback" @cancelImgVerify="cancelImgVerify" ref="cnverify_popup">
			<template v-slot:imgverify_head>{{verifyPopupTitle}}</template>
		</ydverify>
		
		
		
		<!-- 弹窗 -->
		<uni-popup ref="operate_popup" background-color="#fff" @change="popChange">
			<div v-if="popEvent=='to_browser'" class="width300 padding20 center">
				<div class="size2  bold">
					请在浏览器打开网站
				</div><div class="size4 color_red">
					（因微信拦截了支付宝）
				</div>
				<div @click="copyToBoard" class="color5 bg_green margint40r center radius10 padding10 color1 fullwidth ">
					{{host}}  复制 
				</div>
				<!-- <div class="left margint40r   padding10 color1 fullwidth ">方法1：复制网址，在浏览器打开</div> -->
				<div class="left   padding10 color1 fullwidth  ">
					或点右上角，选
					<span class=" color_blue ">在浏览器打开</span>
					
				</div>
			</div>
		</uni-popup>
		
	</div>

</template>

<script>
	import uniPopup from '@/components/uni-popup/uni-popup.vue';
	import chineseverify from '@/components/chineseverify/chineseverify.vue';
	import ydverify from '@/components/imgverify/ydverify.vue';
	
	export default {
		components:{
			chineseverify,
			ydverify,uniPopup
		},
		data() {
			return {
				phone:"",
				smsCode:"",//用于证明手机号拥有
				verifyCode:"",//用于证明不是机器操作
				boxHeight:0,
				//chineseverifyImg:"",
				imgBoxTop:0,
				imgBoxLeft:0,
				index:0,
				rightArr:[],
				showPopup:false,
				verifyPopupTitle:"",
				pwPlaceholder:"短信验证码或密码",
				logo:"",
				
				popEvent:"",
				host:""
			}
		},
		
		/**
		 * this.$emit不是全局的。
		 * uni.$emit、 uni.$on 、 uni.$once 、uni.$off 触发的事件都是 App 全局级别的，跨任意组件，页面，nvue，vue 等
		使用时，注意及时销毁事件监听，比如，页面 onLoad 里边 uni.$on 注册监听，
		onUnload 里边 uni.$off 移除，或者一次性的事件，直接使用 uni.$once 监听
		 */
		created() {
			
			var that=this;
			
			this.host = window.$config.host;
			
			//是否已登录
			var user=window.$utils.uniapi.getStorageSync("user")||{};
			if(typeof user.id!='undefined'){
				window.$utils.uniapi.showToast({
					title:"已登录",icon:"none"
				})
				setTimeout(function(){window.$utils.uniapi.navigateBack();},1000);
			}
			
			// //监听
			// uni.$on("cancelImgVerify",function(){
			// 	console.log("......cancelImgVerify");
			// 	that.showPopup=false;
			// });
			
			
			this.logo=window.$config.logo;
			
			//界面调整位置
			try {
			    const res = window.$utils.uniapi.getSystemInfoSync();
				console.log(res);
			    this.boxHeight=res.windowHeight-50;
			} catch (e) {
			    window.$utils.uniapi.showToast({ title:e });
			}
			
			//this.getVerifyCode("");
			
			
			// 位置
			// try{
			// 	const query = uni.createSelectorQuery();
			// 	query.select('#verifyimg_box').boundingClientRect(data => {
			// 	  console.log("得到布局位置信息" + JSON.stringify(data));
			// 	  console.log("节点离页面顶部的距离为" + data.top);
			// 	  this.imgBoxTop=data.top;
			// 	  this.imgBoxLeft=data.left;
			// 	}).exec();
			// }catch(e){
			// 	console.log(e);
			// }
			
			
			
			// 调用
			// var that=this;
			// setTimeout(function(){
			// 	that.$refs.cnverify_popup.getVerifyCode("");
			// 	},2000
			// 	);
			
			
			
			//在微信浏览器
			if(window.$utils.isInWeixin()){
				//弹窗
				this.popEvent="to_browser";
				this.popOpen("center");
			}
			
		},
		onUnload() {
			//注销监听
			// uni.$off("cancelImgVerify");
		},
		
		methods: {
			
			// 点击事件触发复制
			copyToBoard() {
				var text=window.$config.host;;//window.location.href
				window.$utils.uniapi.setClipboardData(text);
			},
			
			popChange(e) {
				console.log('当前模式：' + e.type + ',状态：' + e.show);
				if(!e.show)this.fnTree=[];//关闭时清除
				
			},
			popOpen(type) {
				this.popType = type;
				// open 方法传入参数 等同在 uni-popup 组件上绑定 type属性
				this.$nextTick(() => {
					this.$refs.operate_popup.open(type);
				});
			},
			popClose(){
				if(this.$refs.operate_popup)this.$refs.operate_popup.close();
			},
			
			
			
			
			doLogin(){
				console.log("doLogin...");
				// this.showPopup=true;
				// this.$refs.cnverify_popup.getVerifyCode("");
				// return;
				
				var phone=this.phone;
				var smsCode=this.smsCode;
				if(!!phone==false || !!smsCode==false){
					window.$utils.uniapi.showToast({ title:"需要手机号和验证码",icon:"none"});
					return;
				}
				this.$axios.request({
					url: window.$config.url.doLogin,
					data: {phone:phone,smsCode:smsCode}
				})
				.then(res => {
					if(!!res.code==true && res.code==window.$config.resCode.SUCCESS){
						var user=res.data;
						if(typeof user.tokenExpireIn!="undefined"){
							user.tokenExpireIn=new Date().getTime()/1000+user.tokenExpireIn;
						}
						window.$utils.uniapi.setStorageSync("user",user);
						window.$utils.uniapi.showToast({ title:res.msg,icon:"none" });
						
						this.$router.go(-1);
						//window.$utils.uniapi.navigateBack();
					}else if(!!res.msg==true){
						window.$utils.uniapi.showToast({ title:res.msg,icon:"none" });
					}else{
						window.$utils.uniapi.showToast({ title:"不成功",icon:"none" });
					}
				});
			},
			// imgVerifySuccessCallback(d){
			// 	console.log("imgVerifySuccessCallback",d);
			// },

			
			//发送短信验证码
			sendSmsCode(){
				var that=this;
				this.imgVerifyEvent="sendsms";
				//显示popup
				this.showPopup=true;
				this.$refs.cnverify_popup.getVerifyCode(this.phone); //调用popup插件方法
				this.verifyPopupTitle="即将发送短信验证码";
				
				// console.log("监听 imgVerifySuccessCallback");
				// uni.$off("imgVerifySuccessCallback");
				// uni.$on("imgVerifySuccessCallback",function(d){
				// 	that.showPopup=false;
				// 	console.log("imgVerifySuccessCallback",d);
				// 	//return;
					
				// 	//发送短信
				// 	that.$axios.request({
				// 		url: window.$config.url.sendSmsCode,
				// 		data: {phone:that.phone,verifyCode:d.verifyCode}
				// 	})
				// 	.then(res => {
						
				// 		if(!!res.code==true && res.code==window.$config.resCode.SUCCESS){
				// 			uni.showToast({ title:"短信发送成功",icon:"none" });
							
				// 		}else if(!!res.msg==true){
				// 			uni.showToast({ title:res.msg,icon:"none" });
				// 		}else{
				// 			uni.showToast({ title:"不成功",icon:"none" });
				// 		}
				// 	});
				// });
				
				
			},
			
			inputPhone(){
				var that=this;
				setTimeout(() => {
					console.log()
				    if(that.phone.length==11 && that.phone.match(/^\d+$/) ){
						that.pwPlaceholder="短信验证码";
					}else{
						that.pwPlaceholder="短信验证码或密码";
					}
				}, 100);
			},
			
			cancelImgVerify(){
				console.log("......cancelImgVerify");
				this.showPopup=false;
			},
			// 旋转图片完成回调
			imgVerifyCallback(d){
				console.log("imgVerifyCallback 旋转图片完成回调",d);
				var that=this;
				that.showPopup=false;
				
				
				if(this.imgVerifyEvent=="login"){
					
					//登录
					var params={account:this.phone,password:this.smsCode};
					params=Object.assign(params,d)
					that.doLogin2(params);
				}
				else if(this.imgVerifyEvent=="sendsms"){
					
					//发送短信
					that.$axios.request({
						url: window.$config.url.sendSmsCode,
						data: {
							phone:that.phone,
							imgVerifyKey:d.imgVerifyKey,
							imgVerifyVal:d.imgVerifyVal,
						}
					})
					.then(res => {
						
						if(!!res.code==true && res.code==window.$config.resCode.SUCCESS){
							window.$utils.uniapi.showToast({ title:res.msg,icon:"none" });
							
						}else if(!!res.msg==true){
							window.$utils.uniapi.showToast({ title:res.msg,icon:"none" });
						}else{
							window.$utils.uniapi.showToast({ title:"不成功",icon:"none" });
						}
					});
				}
				
			},
			
			/**
			 * 获得短信码或图片旋转值后二次登录
			 * 账密登录需携带旋转值, 手机号登录需短信码
			 * @param {Object} params
			 */
			doLogin2(params){
				var that=this;
				that.showPopup=false;
				
				this.$axios.request({
					url: window.$config.url.doLogin,
					data: params
				})
				.then(res => {
					if(!!res.code==true && res.code==window.$config.resCode.SUCCESS){
						window.$utils.uniapi.setStorageSync("last_login_account",!!params.account==true?params.account:params.phone)
						
						window.$utils.uniapi.setStorageSync("user",res.data);
						window.$utils.uniapi.showToast({ title:res.msg,icon:"none" });
						console.log("发起IM登录@user-login");
						app.loginIM();
						
						//构建菜单
						app.makeMenu();
						
						// uni.navigateTo({ url:"/pages/user/home" });
						this.$router.push({ path:"/tabbar_system_menu" });
						
					}else if(!!res.msg==true){
						window.$utils.uniapi.showToast({ title:res.msg,icon:"none" });
					}else{
						window.$utils.uniapi.showToast({ title:"不成功",icon:"none" });
					}
				});
			},
			
			

		},
		
		
	}
</script>

<style scoped>
	 
</style>



// WEBPACK FOOTER //
// src/views/user/login.vue